import {calculateTotalPrice} from "./interactiveColor/script.js";
import {debounce} from './utils.js';
import IMask from "imask";

export function inputs() {

    var elementPhone = document.querySelectorAll('input[name="phone"]');
    var maskOptions = {
        mask: '+7 (000) 000-00-00',
        prepare: function (appended, masked) {
            if (appended === '8' && masked.value === '') {
                return '';
            }
            return appended;
        },
    };
    elementPhone.forEach((el) => {
        new IMask(el, maskOptions);
    });



    var elementTime = document.querySelectorAll('input[name="time_delivery"]');

    var maskTimeOptions = {
        mask: 'HH:MM',

        blocks: {
            HH: {
                mask: IMask.MaskedRange,
                from: 0,
                to: 23,
            },
                MM: {
                mask: IMask.MaskedRange,
                from: 0,
                to: 59,
            }
        }
    };

    elementTime.forEach((el) => {
        new IMask(el, maskTimeOptions);
    });
    


    const momentFormat = 'DD.MM.YYYY';

    let curYear = new Date().getFullYear();
    let curDay = new Date().getDate();
    let curMonth = new Date().getMonth() + 1;

    var elementDateDelivery = document.querySelectorAll('input[name="date_delivery"]');

    var maskDateOptions = {
        mask: Date,
        pattern: momentFormat,

        blocks: {
            YYYY: {
                mask: IMask.MaskedRange,
                // from: year,
                to: 2300
            },
            MM: {
                mask: IMask.MaskedRange,
                // from: month,
                to: 12
            },
            DD: {
                mask: IMask.MaskedRange,
                // from: day,
                to: 31
            },
        }
    };

    var elementDateOrder = document.querySelectorAll('input[name="data_orders"]');

    elementDateOrder.forEach((el) => {
        new IMask(el, maskDateOptions);
    })

    elementDateDelivery.forEach((el) => {
        new IMask(el, maskDateOptions);
        el.addEventListener('input',(evt) => {
            let inputDay = el.value.slice(0, 2);
            let inputMonth = el.value.slice(3, 5);
            let inputYear = el.value.slice(6, 10);
            let replacedYear = ''
            if(Number(inputYear) == curYear) {
                replacedYear = curYear;
            }
            if (Number(inputYear) < curYear && inputYear.length == 4) {
                replaceChars(el, 6, 10, curYear);
                replacedYear = curYear;
            };
            curMonth = `${curMonth}`
            if(curMonth.length == 1) curMonth = 0 + curMonth;
            curDay = `${curDay}`
            if(curDay.length == 1) curDay = 0 + curDay;

            let newMonth = '';
            setTimeout(() => {
                if(Number(inputMonth) == Number(curMonth)) {
                    newMonth = curMonth;
                }
                if(replacedYear == curYear && Number(inputMonth) < Number(curMonth)) {
                    replaceChars(el, 2, 6,'.' + curMonth + '.');
                    newMonth = curMonth;
                };
            }, 50);
            setTimeout(() => {
                if(replacedYear == curYear && Number(newMonth) == Number(curMonth) && Number(inputDay) < Number(curDay)) {
                    console.log('2');
                    replaceChars(el, 0, 2, curDay);
                };
            }, 150);
        })
    });

    function replaceChars(input, firstChar, lastChar, newValue) {
        let inputValue = input.value
        if (inputValue.length >= lastChar) {
            let someChars = inputValue.substring(firstChar, lastChar);
            let someNewValue = inputValue.replace(someChars, `${newValue}`);
            input.value = someNewValue;
        }
    }


    const passInput = document.querySelector('input[name="password"]')
    const repearPassInput = document.querySelector('input[name="repeat_password"]');
    if(repearPassInput) {
        repearPassInput.addEventListener('input',() => {
            if(passInput.value !== repearPassInput.value) {
                repearPassInput.parentElement.classList.add('error');
                passInput.parentElement.classList.add('error');
            } else {
                repearPassInput.parentElement.classList.remove('error');
                passInput.parentElement.classList.remove('error');
            }
        });
        passInput.addEventListener('input',() => {
            if(passInput.value !== repearPassInput.value) {
                repearPassInput.parentElement.classList.add('error');
                passInput.parentElement.classList.add('error');
            } else {
                repearPassInput.parentElement.classList.remove('error');
                passInput.parentElement.classList.remove('error');
            }
        });
    };

    const showPassBtn = document.querySelectorAll('.show__pass');
    showPassBtn.forEach((el) => {
        el.addEventListener('click', (evt) => {
            const findInput = Array.from(el.parentNode.children).find((el) => el.localName == 'input')
            if (el.classList.contains('active')) {
                el.classList.remove('active');
                findInput.type = 'password';
                el.innerHTML = `
                    <svg width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1.42012 8.71318C1.28394 8.49754 1.21584 8.38972 1.17772 8.22342C1.14909 8.0985 1.14909 7.9015 1.17772 7.77658C1.21584 7.61028 1.28394 7.50246 1.42012 7.28682C2.54553 5.50484 5.8954 1 11.0004 1C16.1054 1 19.4553 5.50484 20.5807 7.28682C20.7169 7.50246 20.785 7.61028 20.8231 7.77658C20.8517 7.9015 20.8517 8.0985 20.8231 8.22342C20.785 8.38972 20.7169 8.49754 20.5807 8.71318C19.4553 10.4952 16.1054 15 11.0004 15C5.8954 15 2.54553 10.4952 1.42012 8.71318Z" stroke="#1C1917" stroke-opacity="0.4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M11.0004 11C12.6573 11 14.0004 9.65685 14.0004 8C14.0004 6.34315 12.6573 5 11.0004 5C9.34355 5 8.0004 6.34315 8.0004 8C8.0004 9.65685 9.34355 11 11.0004 11Z" stroke="#1C1917" stroke-opacity="0.4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                `;
            } else {
                el.classList.add('active');
                findInput.type = 'text';
                el.innerHTML = `
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.7429 5.09232C11.1494 5.03223 11.5686 5 12.0004 5C17.1054 5 20.4553 9.50484 21.5807 11.2868C21.7169 11.5025 21.785 11.6103 21.8231 11.7767C21.8518 11.9016 21.8517 12.0987 21.8231 12.2236C21.7849 12.3899 21.7164 12.4985 21.5792 12.7156C21.2793 13.1901 20.8222 13.8571 20.2165 14.5805M6.72432 6.71504C4.56225 8.1817 3.09445 10.2194 2.42111 11.2853C2.28428 11.5019 2.21587 11.6102 2.17774 11.7765C2.1491 11.9014 2.14909 12.0984 2.17771 12.2234C2.21583 12.3897 2.28393 12.4975 2.42013 12.7132C3.54554 14.4952 6.89541 19 12.0004 19C14.0588 19 15.8319 18.2676 17.2888 17.2766M3.00042 3L21.0004 21M9.8791 9.87868C9.3362 10.4216 9.00042 11.1716 9.00042 12C9.00042 13.6569 10.3436 15 12.0004 15C12.8288 15 13.5788 14.6642 14.1217 14.1213" stroke="#1C1917" stroke-opacity="0.4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                `;
            }
        })
    });

    $(function () {
        $(".slider").slider({
            range: "min",
            max: 999,
            slide: function (event, ui) {
                $(".square").val(ui.value);
                debouncedCalculateTotalPrice();
            }
        });

        $(".square").val($(".slider").slider("value"));

        $(".square").on("input", function () {
            var value = $(this).val();
            $(".slider").slider("value", value);

            debouncedCalculateTotalPrice();
        });
    });
}

const debouncedCalculateTotalPrice = debounce(calculateTotalPrice, 750)